import { CSSObject } from '@emotion/react';
import { transparentize } from 'color2k';
import { Colors } from '~/theme/themes/colors/baseColors';

type IndicateScrollFadeProps = {
    height: string | number;
    color: keyof Colors | string;
    place: 'top' | 'bottom' | 'both';
    transparency?: number;
};

const sharedStyle: CSSObject = {
    content: '""',
    position: 'sticky',
    display: 'block',
    pointerEvents: 'none',
    // Don't overlap scrollbar
    marginRight: 6,
    zIndex: 5,
};

/**
 * Adds a pseudoelement that indicates additional content exist when scrolled.
 * Right now height and color is variable. Add more if needed, e.g. position
 */
export const indicateScrollFade = ({
    height,
    color,
    place,
    transparency = 1,
}: IndicateScrollFadeProps): CSSObject => ({
    ...((place === 'top' || place === 'both') && {
        '&:before': {
            ...sharedStyle,
            inset: '0 0 auto',
            height,
            background: `linear-gradient(to bottom, ${color} 0%, ${transparentize(
                color,
                transparency
            )} 100%)`,
        },
    }),
    ...((place === 'bottom' || place === 'both') && {
        '&:after': {
            ...sharedStyle,
            inset: 'auto 0 0',
            height,
            background: `linear-gradient(to top, ${color} 0%, ${transparentize(
                color,
                transparency
            )} 100%)`,
        },
    }),
});
